import { colors } from '@/constants/colors';
import React from 'react';
import styled from 'styled-components';

interface Props {
   title: string;
   type: string;
   size: string;
}

const BtnNormal = ({ title, type, size }: Props) => {
   return (
      <Wrapper size={size} type={type}>
         <Content>
            <Title>{title}</Title>
         </Content>
      </Wrapper>
   );
};

const Wrapper = styled.div<{
   size: string;
   type: string;
}>`
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: ${({ type }) =>
      type === 'primary'
         ? `${colors.PRIMARY}`
         : type === 'dark'
         ? '#1D1D1F'
         : `${colors.DANGER}`};
   border-radius: 5px;
   cursor: pointer;
   width: ${({ size }) => (size === 'small' ? '100px' : 'auto')};
   height: 40px;
   transition: all 0.3s ease-in-out;
   :hover {
      /* background-color: ${(props) => props.theme.colors.secondary}; */
      transition: all 0.3s ease-in-out;
   }
`;
const Content = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
`;

const Title = styled.p`
   font-size: 16px;
   font-weight: 600;
   color: white;
`;

export default BtnNormal;
